const InvoiceSettled = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 1.33333H8V0H7.33333V1.33333H2.66667V0H2V1.33333H1C0.734784 1.33333 0.48043 1.43869 0.292893 1.62623C0.105357 1.81376 0 2.06812 0 2.33333L0 9C0 9.26522 0.105357 9.51957 0.292893 9.70711C0.48043 9.89464 0.734784 10 1 10H9C9.26522 10 9.51957 9.89464 9.70711 9.70711C9.89464 9.51957 10 9.26522 10 9V2.33333C10 2.06812 9.89464 1.81376 9.70711 1.62623C9.51957 1.43869 9.26522 1.33333 9 1.33333ZM4.68267 7.488L7.25067 4.55267L6.74933 4.114L4.65067 6.51267L3.56933 5.43067L3.09733 5.90267L4.68267 7.488Z"
        fill="#10B981"
      />
    </svg>
  );
};
export default InvoiceSettled;
